(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
if (!customElements.get('kom-product-description')) {
  customElements.define('kom-product-description', class extends HTMLElement {
    connectedCallback() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.foldCare(), { once: true });
      } else {
        this.foldCare();
      }
    }

    foldCare() {
      const clean = text => text.replace(/\s+/g, ' ').trim();
      const isCare = text => /^(?:(?:gu[ií]a|instrucciones|recomendaciones) de |(?:preservaci[oó]n|protecci[oó]n) y )?cuidados?(?: del producto| de la prenda)?\s*:?[\s]*$/i.test(clean(text));
      const isHeading = element => {
        if (/^H[1-6]$/.test(element.tagName)) return true;
        const bold = element.querySelector('strong, b');
        return bold && clean(bold.textContent) === clean(element.textContent);
      };
      for (const block of Array.from(this.querySelectorAll('p, h1, h2, h3, h4, h5, h6'))) {
        if (block.closest('details, li, table')) continue;
        const marker = isCare(block.textContent) ? block : Array.from(block.querySelectorAll('strong, b')).find(element => isCare(element.textContent));
        if (!marker || !clean(block.textContent).startsWith(clean(marker.textContent))) continue;
        const content = document.createElement('div');
        content.className = 'kom-care__content prose';
        const inline = marker !== block && clean(marker.textContent) !== clean(block.textContent);
        if (inline) {
          const remaining = block.cloneNode(true);
          const copiedMarker = Array.from(remaining.querySelectorAll('strong, b')).find(element => isCare(element.textContent));
          copiedMarker.remove();
          content.append(remaining);
        }
        let sibling = block.nextElementSibling;
        let hasInstructions = inline;
        while (sibling) {
          const text = clean(sibling.textContent);
          const next = sibling.nextElementSibling;
          const isList = /^(UL|OL)$/.test(sibling.tagName);
          const isBullet = /^[-–—•]/.test(text);
          const isIntro = !hasInstructions && sibling.tagName === 'P' && next && /^(UL|OL)$/.test(next.tagName);
          if (sibling.querySelector('img, iframe, video, table') || sibling.tagName === 'HR' || isHeading(sibling)) break;
          const isInstruction = sibling.tagName === 'P' && /^(lavar|no usar|evitar|importante:)/i.test(text);
          if (text && !isList && !isBullet && !isIntro && !isInstruction) break;
          content.append(sibling);
          if (isList || isBullet) hasInstructions = true;
          sibling = next;
        }
        if (!clean(content.textContent)) continue;
        const details = document.createElement('details');
        details.className = 'kom-care';
        const summary = document.createElement('summary');
        summary.textContent = clean(marker.textContent).replace(/\s*:$/, '');
        details.append(summary, content);
        block.replaceWith(details);
      }
      this.refineDescription();
    }

    refineDescription() {
      if (this.dataset.refined) return;
      this.dataset.refined = 'true';
      const editorial = this.querySelector('template[data-kom-editorial]');
      if (editorial) {
        const care = Array.from(this.querySelectorAll('.kom-care'));
        const content = editorial.content.cloneNode(true);
        const preserve = editorial.hasAttribute('data-preserve-description');
        const detailsLabel = editorial.dataset.detailsLabel;
        editorial.remove();
        if (preserve) {
          const rich = content.querySelector('[data-editorial-features] .metafield-rich_text_field');
          if (rich) {
            const grid = document.createElement('div');
            grid.className = 'kom-editorial__features';
            let feature;
            for (const node of Array.from(rich.children)) {
              if (/^H[1-6]$/.test(node.tagName) || !feature) {
                feature = document.createElement('div');
                feature.className = 'kom-editorial__feature';
                grid.append(feature);
              }
              feature.append(node);
            }
            rich.parentElement.replaceWith(grid);
          }
          care.forEach(node => node.remove());
          const details = document.createElement('details');
          details.className = 'kom-care kom-editorial-original';
          const summary = document.createElement('summary');
          summary.textContent = detailsLabel;
          const original = document.createElement('div');
          original.className = 'kom-care__content prose';
          original.append(...this.childNodes);
          details.append(summary, original);
          this.replaceChildren(content, ...care, details);
        } else {
          this.replaceChildren(content, ...care);
        }
        this.classList.add('kom-description--editorial');
        return;
      }
      const title = (this.dataset.productTitle || '').trim().toLocaleLowerCase();
      const first = this.firstElementChild;
      if (first && !first.querySelector('img,video,iframe') && first.textContent.trim().toLocaleLowerCase() === title) first.remove();
      for (const parent of [this, ...this.querySelectorAll('.kom-care__content')]) {
        let list;
        for (const paragraph of Array.from(parent.children)) {
          if (paragraph.tagName === 'P' && /^\s*[-–—•]\s*/.test(paragraph.textContent) && !paragraph.querySelector('img,iframe,video')) {
            if (!list) {
              list = document.createElement('ul');
              list.className = 'kom-description-list';
              paragraph.before(list);
            }
            const item = document.createElement('li');
            item.innerHTML = paragraph.innerHTML.replace(/^(\s*(?:<[^>]+>\s*)*)[-–—•]\s*/, '$1');
            list.append(item);
            paragraph.remove();
          } else if (paragraph.textContent.trim()) {
            list = null;
          }
        }
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
